import React from "react";
import { LanguageProvider } from "./LanguageContext";
import { usePushNotifications } from "./usePushNotifications";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BecomeProPage from "./pages/BecomeProPage";
import PricingPage from "./pages/PricingPage";
import ServicePage from "./pages/ServicePage";
import BrowseServicesPage from "./pages/BrowseServicesPage";
import SubcategoryListPage from "./pages/SubcategoryListPage";
import SubcategoryProListPage from "./pages/SubcategoryProListPage";
import ServicesManagerPage from "./pages/ServicesManagerPage";
import TemplatesPage from "./pages/TemplatesPage";
import NotificationPreferencesPage from "./pages/NotificationPreferencesPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import HomePage from "./pages/HomePage";
import ExplorePage from "./pages/ExplorePage";
import BookingsPage from "./pages/BookingsPage";
import BookingConfirmationPage from "./pages/BookingConfirmationPage";
import ProDashboardPage from "./pages/ProDashboardPage";
import AdminPage from "./pages/AdminPage";
import ProProfileSetupPage from "./pages/ProProfileSetupPage";
import MessagesPage from "./pages/MessagesPage";
import ProfilePage from "./pages/ProfilePage";
import SavedAddressesPage from "./pages/SavedAddressesPage";
import LeadPricingPage from "./pages/LeadPricingPage";
import ProEarningsPage from "./pages/ProEarningsPage";
import ProProfilePage from "./pages/ProProfilePage";
import QuoteRequestPage from "./pages/QuoteRequestPage";
import ProProfileEditPage from "./pages/ProProfileEditPage";
import AvailabilityPage from "./pages/AvailabilityPage";
import PortfolioPage from "./pages/PortfolioPage";
import SupportChatPage from "./pages/SupportChatPage";
import DisputePage from "./pages/DisputePage";
import HelpPage from "./pages/HelpPage";
import TicketPage from "./pages/TicketPage";
import ProSelectionPage from "./pages/ProSelectionPage";
import ProSignUpPage from "./pages/ProSignUpPage";
import ServiceAreaPage from "./pages/ServiceAreaPage";

function useUserRole() {
  const role = localStorage.getItem("mouna_user_role");
  return role || "client";
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = Object.keys(localStorage).find(k => k.includes("idToken"));
  return token ? <>{children}</> : <Navigate to="/" />;
}
function RoleRouter() {
  const role = useUserRole();

  if (role === "pro") return <ProDashboardPage />;
  if (role === "admin") return <AdminPage />;
  return <HomePage />;
}
function PushNotificationSetup() {
  usePushNotifications();
  return null;
}

export default function App() {
  return (
    <LanguageProvider>
    <BrowserRouter>
      <PushNotificationSetup />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/become-pro" element={<BecomeProPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/browse" element={<BrowseServicesPage />} />
        <Route path="/browse/:categorySlug" element={<SubcategoryListPage />} />
        <Route path="/browse/:categorySlug/:subcategorySlug" element={<SubcategoryProListPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/pro/services" element={<PrivateRoute><ServicesManagerPage /></PrivateRoute>} />
        <Route path="/pro/templates" element={<PrivateRoute><TemplatesPage /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><NotificationPreferencesPage /></PrivateRoute>} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/login" element={<LoginPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route
           path="/home"
          element={
            <PrivateRoute>
              <RoleRouter />
            </PrivateRoute>
          }
        />
<Route path="/explore" element={<ExplorePage />} />
        <Route path="/bookings/confirmation" element={<PrivateRoute><BookingConfirmationPage /></PrivateRoute>} />
        <Route
          path="/bookings"
          element={
            <PrivateRoute>
              <BookingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/pro/setup"
          element={
            <PrivateRoute>
              <ProProfileSetupPage />
            </PrivateRoute>
          }
        />
        <Route path="/messages" element={<PrivateRoute><MessagesPage /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
        <Route path="/profile/addresses" element={<PrivateRoute><SavedAddressesPage /></PrivateRoute>} />
        <Route path="/lead-pricing" element={<LeadPricingPage />} />
        <Route path="/pro/earnings" element={<PrivateRoute><ProEarningsPage /></PrivateRoute>} />
        <Route path="/pro/edit" element={<PrivateRoute><ProProfileEditPage /></PrivateRoute>} />
        <Route path="/pro/availability" element={<PrivateRoute><AvailabilityPage /></PrivateRoute>} />
        <Route path="/pro/portfolio" element={<PrivateRoute><PortfolioPage /></PrivateRoute>} />
        <Route path="/support" element={<PrivateRoute><SupportChatPage /></PrivateRoute>} />
        <Route path="/disputes" element={<PrivateRoute><DisputePage /></PrivateRoute>} />
        <Route path="/help" element={<PrivateRoute><HelpPage /></PrivateRoute>} />
        <Route path="/tickets" element={<PrivateRoute><TicketPage /></PrivateRoute>} />
        <Route path="/select-pro" element={<PrivateRoute><ProSelectionPage /></PrivateRoute>} />
        <Route path="/pro-signup" element={<ProSignUpPage />} />
        <Route path="/pro/service-area" element={<PrivateRoute><ServiceAreaPage /></PrivateRoute>} />
        <Route path="/pro/:proId" element={<ProProfilePage />} />
        <Route path="/quote" element={<PrivateRoute><QuoteRequestPage /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}
